/* eslint-disable @typescript-eslint/no-explicit-any */
import { Box, Button, Group, Modal, Text } from "@mantine/core";
import { generateClient, GraphQLQuery } from "aws-amplify/api";
import { useState } from "react";
import {
  DeleteTemplateInput,
  DeleteTemplateMutation,
  DeleteTemplateMutationVariables
} from "../../API";
import { deleteTemplate } from "../../graphql/mutations";
import { appShowNotification } from "../../utils/utils";
const client = generateClient();
type editPatientProps = {
  modalOpened: boolean;
  setModalOpened: (value: boolean) => void;
  template: any;
  fetchTemplates: () => void;
};

const ConfirmDeleteTemplateModal = (props: editPatientProps) => {
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [errorMsg, setErrorMsg] = useState<string>("");
  const { modalOpened, setModalOpened, template, fetchTemplates } = props;
  const deleteTemplateRequest = async () => {
    // if (template.sections.items.length !== 0) {
    //   appShowNotification({
    //     type: "warning",
    //     title: "Please delete all sections before deleting this template"
    //   });
    //   return;
    // }

    setIsLoading(true);
    try {
      const deleteInput: DeleteTemplateInput = {
        id: template.id,
        _version: template._version
      };

      const deleteInputVars: DeleteTemplateMutationVariables = {
        input: deleteInput
      };

      await client.graphql<GraphQLQuery<DeleteTemplateMutation>>({
        query: deleteTemplate,
        variables: deleteInputVars
      });
      appShowNotification({
        type: "success",
        title: "Template deleted successfully!"
      });
    } catch (err) {
      console.log("error deleting subsection:", err);
      appShowNotification({
        type: "error",
        title: "Fail to delete!"
      });
    }
    fetchTemplates();
    setIsLoading(false);
  };

  return (
    <Modal
      opened={modalOpened}
      onClose={() => {
        setErrorMsg("");
        setModalOpened(false);
      }}
      title="Delete template"
    >
      <Box>
        <Text fw={400} fz={14}>
          Are you sure you want to delete this template?
        </Text>
        {errorMsg && (
          <Text fw={400} fz={14} c="red">
            {errorMsg}
          </Text>
        )}
      </Box>
      <Group mt="md">
        <Group mt="md">
          <Button variant="default" onClick={() => setModalOpened(false)}>
            No
          </Button>
          <Button loading={isLoading} onClick={() => deleteTemplateRequest()}>
            Yes
          </Button>
        </Group>
      </Group>
    </Modal>
  );
};
export default ConfirmDeleteTemplateModal;
